import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks,
} from 'body-scroll-lock';

var lightbox = {
    selectors: {
        element: '[data-lightbox="element"]',
        trigger: '[data-lightbox="trigger"]',
        slides: '[data-lightbox="slides"]',
        prev: '[data-lightbox="prev"]',
        next: '[data-lightbox="next"]',
        current: '[data-lightbox="current"]',
        close: '[data-lightbox="close"]',
    },
    init: function () {
        var self = this;

        $(self.selectors.element).each(function () {
            var $el = $(this),
                $trigger = $(self.selectors.trigger),
                $prev = $el.find(self.selectors.prev),
                $next = $el.find(self.selectors.next),
                $slides = $el.find(self.selectors.slides),
                $current = $el.find(self.selectors.current),
                $close = $el.find(self.selectors.close),
                $lastPos = 0;

            var lightbox = document.querySelector('.post-detail__lightbox');

            $trigger.on('click', function (e) {
                e.preventDefault();

                $(document.body).addClass('lightbox-opened');
                disableBodyScroll(lightbox);
                tinyslider.goTo($lastPos);
            });

            $close.on('click', function (e) {
                e.preventDefault();

                $(document.body).removeClass('lightbox-opened');
                clearAllBodyScrollLocks();
                $lastPos = tinyslider.getInfo().index;
            });

            var tinyslider = tns({
                container: $slides[0],
                items: 1,
                slideBy: 'page',
                autoplay: false,
                controls: false,
                loop: true,
                mode: 'gallery',
                nav: false,
                arrowKeys: true,
            });

            tinyslider.events.on('indexChanged', function (info) {
                $current.html(info.displayIndex);
            });

            $prev.on('click', function () {
                tinyslider.goTo('prev');
            });

            $next.on('click', function () {
                tinyslider.goTo('next');
            });
        });
    },
};

export { lightbox };
